import { channelIconElement } from '../../components/ChannelLegendItem'
import { SummaryMode } from '../../components/charts'
import type { ChartSeriesInput } from '../../components/charts'
import type { ChannelTimeSeries } from '../hooks/useAllChannelsTimeSeries'

/**
 * Builds the `ChartSeriesProvider` inputs for the All-Channels Posts "Bar" view:
 * one Total-mode series per displayed channel over the posts feed. `BarChart`
 * reduces each series to its range total (posts are per-day counts, so the
 * ranked bar is the sum), then sorts longest-first.
 *
 * Colour is left to the provider — each series carries `paletteIndex` = the
 * channel's slot in the full time-series feed (via `paletteIndexById` from
 * {@link useMetricChannels}), so a channel keeps the same hue as its Followers
 * card and the legend. Passing the displayed-order index instead would shift
 * every colour whenever a leading channel is filtered out.
 */
export function toPostsBarSeries(
  displayedChannels: ChannelTimeSeries[],
  paletteIndexById: Map<string, number>,
): ChartSeriesInput[] {
  return displayedChannels.map((ch) => ({
    id: `posts-${ch.channel.id}`,
    label: ch.channel.name,
    icon: channelIconElement(ch.channel.service),
    summaryMode: SummaryMode.TOTAL,
    paletteIndex: paletteIndexById.get(ch.channel.id) ?? 0,
    data: ch.primary.posts.map((p) => ({
      date: p.date,
      value: p.value,
      source: p.source,
    })),
  }))
}
